import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu';
import React, { useCallback, useEffect, useState, useContext } from 'react'
import axios from 'axios';
import { LoadingContext } from "../../context/LoadingContext";
import Swal from 'sweetalert2'
const config = require('../../config.json')

export default function Preproduct({ ipAddress, loginData }) {
    const [loading, setLoading] = useContext(LoadingContext);
    const [data, setData] = useState('')
    const [bal, setBal] = useState(0)


    const handleCall = useCallback(() => {

        let data = JSON.stringify({
            "ip": ipAddress,
            "ulid": loginData.ulid
        });

        let axiosConfig = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}productre`,
            headers: {
                'ip': ipAddress,
                'ulid': loginData.ulid,
                'auth': loginData.auth,
                'token': loginData.token,
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios.request(axiosConfig)
            .then((response) => {
                setData(response.data?.info)
                setBal(response.data?.info?.topup)
                console.log(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [ipAddress, loginData.auth, loginData.token, loginData.ulid])
    useEffect(() => {
        handleCall()
    }, [handleCall])


    const handelRecived = async (id, pname) => {
        Swal.fire({
            title: "AK Herbal",
            icon: 'info',
            text: "Do you Recived Product of Name " + pname,
            showCancelButton: true,
            cancelButtonText: 'Not Recived Yet',
            confirmButtonText: 'Yes Recived',

        }).then((res) => {
            console.log(res.isConfirmed)
            if (res.isConfirmed) {
                let data = JSON.stringify({
                    "ip": ipAddress,
                    "ulid": loginData.ulid,
                    "pack": id,
                });
                //Swal.fire('AK Herbal', "Please wait for geting Information", 'info')
                setLoading(true)
                console.log(data)
                let axiosConfig = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: `${config.baseUrl}/productre`,
                    headers: {
                        'ip': ipAddress,
                        'ulid': loginData.ulid,
                        'auth': loginData.auth,
                        'token': loginData.token,
                        'Content-Type': 'application/json'
                    },
                    data: data
                };
                axios.request(axiosConfig)
                    .then((response) => {
                        setLoading(false)
                        console.log(response.data);
                        let res = response.data;
                        Swal.fire({
                            title: "AK Herbal",
                            icon: 'info',
                            text: res?.message
                        })
                        handleCall()
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        });
    }
    return (
        <>
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <Header />
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y pt-2 mb-4">
                            <div>
                                <div className='row'>
                                    <div className="col-md-12  mb-2">
                                        <div className="card">
                                            <div className="card-header align-items-center ">
                                                <div className="card-title mb-0">
                                                    <h6 className="m-0 text-center text-black ">Rebuy Product</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-12  mb-2">
                                        <div className="card">
                                            <div className="card-header align-items-center ">
                                                <div className="card-title mb-0">
                                                    <h6 className="m-0 me-2 text-center text-black">Buys Products</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        data?.prodbuy?.map((list, index) => {
                                            return (
                                                <div className="col-md-4  mb-1" id={index + 1} key={index + 1}>
                                                    <div className="card h-100">
                                                        <div className="card-header align-items-center" style={{ padding: "3% 5% 3% 5%" }}>
                                                            <div className="col-md-12">
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <span className="text-black text-sm">DP : <i className='bx bx-rupee bx-xs'></i> {list?.paid_amount}</span>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">Buy Date : {list?.dt}</small>
                                                                    </div>
                                                                </div>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <small className="text-sm">Package Name  </small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">{list?.pname} </small>
                                                                    </div>
                                                                </div>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-8 text-left'>
                                                                        <small className="text-sm">MRP :<i className='bx bx-rupee bx-xs'></i>{list?.paid_mrp}</small>
                                                                    </div>
                                                                    <div className='col-4' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">BV <i className='bx bx-coin bx-xs'></i>{list?.paid_bv}</small>
                                                                    </div>
                                                                </div>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <small className="text-sm">{(list?.is_send == 1) ? 'Dispatched:Yes' : 'Dispatched:No'} </small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm"> Dispatch Date :{list?.sdt}</small>
                                                                    </div>
                                                                </div>
                                                                {(list?.is_send == 1 && list?.is_recived == 0) ? <>
                                                                    <div className="card-info align-items-center mb-2">
                                                                        <div className='text-center mt-0'>
                                                                            <button className='btn  btn-info rounded-pill btn-xs' onClick={() => handelRecived(list.id, list.pname)}>Recived {list.panem} of <i className='bx bx-rupee bx-xs'></i>{list.paid_amount}</button>
                                                                        </div>
                                                                    </div></> : <></>}
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <small className="text-sm">{(list?.is_recived == 1) ? 'Recived:Yes' : 'Recived:No'} </small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm"> Recived Date :{list?.rdt}</small>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}